import * as React from 'react';

import { FooterContainer } from '../../types/FooterContainer';
import { MobileFooterContainer } from '../MobileFooterContainer';
import { LegalDocumentsContainer } from '../LegalDocumentsContainer';
import { LinksBlockContainer } from '../LinksBlockContainer';
import { CianGroupContainer } from '../CianGroupContainer';
import { ProjectsBlockContainer } from '../ProjectsBlockContainer';
import { BottomStripeContainer } from '../BottomStripeContainer';

export const LayoutContainer: React.FC = () => (
  <>
    <FooterContainer
      legalDocuments={<LegalDocumentsContainer />}
      links={<LinksBlockContainer />}
      cianGroup={<CianGroupContainer />}
      projects={<ProjectsBlockContainer />}
      bottomStripe={<BottomStripeContainer />}
    />
    <MobileFooterContainer />
  </>
);
